import { PageGen, PdfBrush, PdfColor, PdfFont, PdfRect, ETextAlign } from '../pdf';
import { GUtil } from '../gutil';
import { ELogicoVariant, drawLogicoCircle } from './logico';

export class RelRect {
  constructor(
    public readonly x: number,
    public readonly y: number,
    public readonly width: number,
    public readonly height: number
  ) {}

  public get left(): number {
    return this.x;
  }
  public get top(): number {
    return this.y;
  }
  public get right(): number {
    return this.x + this.width;
  }
  public get bottom(): number {
    return this.y + this.height;
  }
}

export class Rel<T> {
  constructor(
    public readonly data: T,
    public readonly rect: RelRect
  ) {}
}

export function drawRelBoxes<T>(
  g: PageGen,
  rect: PdfRect,
  items: Rel<T>[],
  drawBox: (g: PageGen, item: Rel<T>, rect: PdfRect) => void
): void {
  if (items.length === 0) return;

  const minX = Math.min(...items.map((i) => i.rect.x));
  const maxX = Math.max(...items.map((i) => i.rect.x + i.rect.width));
  const minY = Math.min(...items.map((i) => i.rect.y));
  const maxY = Math.max(...items.map((i) => i.rect.y + i.rect.height));

  const boundsWidth = maxX - minX;
  const boundsHeight = maxY - minY;

  const d = Math.min(rect.width / boundsWidth, rect.height / boundsHeight);
  const px = rect.x + (rect.width - boundsWidth * d) / 2;
  const py = rect.y + (rect.height - boundsHeight * d) / 2;

  for (const item of items) {
    const boxRect = new PdfRect(
      px + (item.rect.x - minX) * d,
      py + (item.rect.y - minY) * d,
      item.rect.width * d,
      item.rect.height * d
    );
    drawBox(g, item, boxRect);
  }
}
